var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"title":"privacy_policy.pdf","id":"pdf-iframe","src":_vm.pdfLink,"allow":"fullscreen","frameborder":"0","marginheight":"0","marginwidth":"0","width":"100%","height":"100%","scrolling":"auto"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1811e184","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivacyPolicy.vue
// module id = Ofcu
// module chunks = 1